import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RangoSalarialPerfilService } from '../services/rango-salarial-perfil.service';
import * as RangoSalarialPerfilActions from './rango-salarial-perfil.actions';

@Injectable()
export class RangoSalarialPerfilEffects {
  private readonly actions$ = inject(Actions);
  private readonly rangoSalarialPerfilService = inject(RangoSalarialPerfilService);
  private readonly store = inject(Store);

  // Load Rangos Salariales
  loadRangosSalariales$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RangoSalarialPerfilActions.loadRangosSalariales),
      switchMap(() =>
        this.rangoSalarialPerfilService.getRangosSalariales().pipe(
          map(rangosSalariales =>
            RangoSalarialPerfilActions.loadRangosSalarialesSuccess({ rangosSalariales })
          ),
          catchError(error => {
            return of(
              RangoSalarialPerfilActions.loadRangosSalarialesFailure({
                error: error.message || 'Error al cargar los rangos salariales'
              })
            );
          })
        )
      )
    )
  );

  // Create Rango Salarial
  createRangoSalarialPerfil$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RangoSalarialPerfilActions.createRangoSalarialPerfil),
      switchMap(action =>
        this.rangoSalarialPerfilService.createRangoSalarial(action.rangoSalarial).pipe(
          switchMap(result =>
            this.rangoSalarialPerfilService.getRangoSalarialById(result.id).pipe(
              map(createdRangoSalarial =>
                RangoSalarialPerfilActions.createRangoSalarialPerfilSuccess({
                  rangoSalarial: createdRangoSalarial
                })
              )
            )
          ),
          catchError(error => {
            return of(
              RangoSalarialPerfilActions.createRangoSalarialPerfilFailure({
                error: error.message || 'Error al crear el rango salarial'
              })
            );
          })
        )
      )
    )
  );

  // Update Rango Salarial
  updateRangoSalarialPerfil$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RangoSalarialPerfilActions.updateRangoSalarialPerfil),
      switchMap(action =>
        this.rangoSalarialPerfilService.updateRangoSalarial(action.id, action.rangoSalarial).pipe(
          switchMap(() =>
            this.rangoSalarialPerfilService.getRangoSalarialById(action.id).pipe(
              map(updatedRangoSalarial =>
                RangoSalarialPerfilActions.updateRangoSalarialPerfilSuccess({
                  rangoSalarial: updatedRangoSalarial
                })
              )
            )
          ),
          catchError(error => {
            return of(
              RangoSalarialPerfilActions.updateRangoSalarialPerfilFailure({
                error: error.message || 'Error al actualizar el rango salarial'
              })
            );
          })
        )
      )
    )
  );
}
